import { Box } from "@chakra-ui/react";
import { colors, getCdnImageSrc, HStack, Image, useResponsive, VStack } from "goi_common";
import { MatchRecommenationQuotationType } from "../../type/MatchRecommendationType";

import { RecommendationServiceDetail } from "./RecommendationServiceDetail";

interface RecommendationCardProps {
  item?: MatchRecommenationQuotationType;
  isFirst?: boolean;
  hasMore?: boolean;
  handleCardClick?: (id?: number) => void;
  quotationRequestId?: number;
}
function RecommendationCard({
  item,
  isFirst,
  hasMore,
  handleCardClick,
  quotationRequestId,
}: RecommendationCardProps) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack padding="0 0 20px 0">
      <Box
        style={{
          boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.12)",
          borderRadius: "8px",
          backgroundColor: colors.white,
        }}
      >
        {isBiggerThanLg ? (
          <HStack>
            <Box width="100%" style={{ aspectRatio: "304 / 226" }} backgroundColor={colors.gray50}>
              <Image
                alt="sangjoBackground"
                width="100%"
                height="auto"
                style={{
                  borderRadius: "8px 0 0 8px",
                }}
                src={getCdnImageSrc(
                  item?.sangjo?.id
                    ? `platform/sangjos/${item.sangjo.id}/thumbnail.png`
                    : `platform/sangjos/match-recommendation-default.png`,
                )}
              ></Image>
            </Box>
            <VStack justifyContent="space-between" width="100%">
              <RecommendationServiceDetail
                servicePackage={item?.package}
                isFirst={isFirst}
                hasMore={hasMore}
                handleCardClick={() => handleCardClick?.(item?.id)}
                quotationRequestId={quotationRequestId}
              />
            </VStack>
          </HStack>
        ) : (
          <VStack>
            <Box width="100%" style={{ aspectRatio: "304 / 226" }} backgroundColor={colors.gray50}>
              <Image
                alt="sangjoBackground"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px 8px 0 0",
                }}
                src={getCdnImageSrc(
                  item?.sangjo?.id
                    ? `platform/sangjos/${item.sangjo.id}/thumbnail.png`
                    : `platform/sangjos/match-recommendation-default.png`,
                )}
              ></Image>
            </Box>
            <RecommendationServiceDetail
              servicePackage={item?.package}
              isFirst={isFirst}
              hasMore={hasMore}
              handleCardClick={() => handleCardClick?.(item?.id)}
              quotationRequestId={quotationRequestId}
            />
          </VStack>
        )}
      </Box>
    </VStack>
  );
}

export default RecommendationCard;
